var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-interno',{scopedSlots:_vm._u([{key:"topo",fn:function(){return [_c('topo')]},proxy:true}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }